import { createSlice } from '@reduxjs/toolkit';

// Initialize state with default values
const initialState = {
  isAuthenticated: false,
  user: null,
  modules: [],
};

// Fetch data from localStorage and parse if available
const storedUser = localStorage.getItem('user');
const storedAuth = localStorage.getItem('isAuthenticated');

// Check if data exists in localStorage and parse it correctly
if (storedUser && storedAuth) {
  try {
    initialState.isAuthenticated = JSON.parse(storedAuth); // Parse boolean value
    initialState.user = JSON.parse(storedUser); // Parse user object
  } catch (error) {
    console.error("Error parsing data from localStorage", error);
  }
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;

      // Store the user data and authentication status in localStorage
      localStorage.setItem('user', JSON.stringify(action.payload));
      localStorage.setItem('isAuthenticated', JSON.stringify(true));
    },
    AddModule: (state, action) => {
      state.modules = action.payload;

      // Store the user data and authentication status in localStorage
      localStorage.setItem('user', JSON.stringify(action.payload));
      localStorage.setItem('isAuthenticated', JSON.stringify(true));
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;

      // Remove user data and authentication status from localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('authToken');
    },
  },
});

export const { login, logout,AddModule } = userSlice.actions;
export default userSlice.reducer;
